import { useEffect } from 'react';

export default function FullScreenView({
  photo,
  onClose,
  onPrev,
  onNext,
  hasPrev,
  hasNext,
  actionArea,
}) {
  useEffect(() => {
    const handleKey = (e) => {
      const tag = e.target?.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      if (e.key === 'ArrowLeft' && hasPrev) onPrev();
      if (e.key === 'ArrowRight' && hasNext) onNext();
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [hasPrev, hasNext, onPrev, onNext, onClose]);

  useEffect(() => {
    if (!photo) return;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) return;
    const original = meta.content;
    meta.content = '#1F3A5F';
    return () => { meta.content = original; };
  }, [photo]);

  if (!photo) return null;

  return (
    <div className='fs-overlay'>
      <img src={photo.displayURL} alt='' className='fs-image' />

      {/* Close */}
      <button onClick={onClose} className='fs-close-btn'>
        ✕
      </button>

      {/* Prev */}
      {hasPrev && (
        <button onClick={onPrev} className='fs-nav-btn fs-nav-prev'>
          ‹
        </button>
      )}

      {/* Next */}
      {hasNext && (
        <button onClick={onNext} className='fs-nav-btn fs-nav-next'>
          ›
        </button>
      )}

      {/* Action area — rendered by parent */}
      {actionArea && (
        <div className='fs-action-area'>
          {actionArea}
        </div>
      )}
    </div>
  );
}